import React from "react";
import { INDUSTRIES } from "@/constants/testIds";

const ITEMS = [
  "Schools",
  "Colleges",
  "Cafés",
  "Restaurants",
  "Gyms",
  "Boutiques",
  "Hospitals",
  "Startups",
  "SMEs",
  "Enterprises",
  "Real Estate",
  "Corporate",
];

const Industries = () => {
  const doubled = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid={INDUSTRIES.root}
      className="relative overflow-hidden border-y border-white/[0.06] bg-[#060606] py-10"
      aria-label="Industries we serve"
    >
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-[#060606] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-[#060606] to-transparent" />

      <div className="marquee-track">
        {doubled.map((item, idx) => (
          <div key={`${item}-${idx}`} className="flex items-center gap-12">
            <span className="font-display text-2xl font-semibold tracking-tight text-zinc-300 sm:text-3xl">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-[var(--gold)]/50" />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Industries;
